<!--
 * @Author: xiaokun
 * @Date: 2020-04-09 20:25:28
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-18 10:15:23
 * @Description: 考试模块
 -->
<template>
  <div class="examination-manage">
    <div class="examination-manage-table-wrapper">
      <!-- 列表 -->
      <list-biz
        ref="listBiz"
        class="examination-manage__table"
        :config="config"
        :data="data"
        :total="total"
        :page="params.page"
        @on-current-change="handleOnCurrentChange"
        @on-delete-click="handleOnDeleteChange"
        @on-edit-click="handleEditExamination"
      >
        <ds-search
          slot="search"
          :form-schema="formSchema"
          @on-search-click="handleOnSearchClick"
          @on-reset-click="handleOnResetClick"
        >
          <mk-button
            slot="toolbar"
            type="primary"
            icon="el-icon-plus"
            @click="handleOnOpenClick"
          >
            新建考试
          </mk-button>
        </ds-search>
      </list-biz>
      <!-- 不可删除确认框 -->
      <list-table-action-dialog
        v-if="isOpenDelete"
        :type="'error'"
        :title="dialogContent.title"
        :text="dialogContent.text"
        :visible="isOpenDelete"
        @on-enter-click="handleOnDeleteEnterClick"
        @on-close="handleOnDeleteEnterClick"
      />
    </div>
  </div>
</template>
<script>
import List from './examination-table-components/index.js'
import ListTableActionDialog from './examination-table-components/list-table-action-dialog'
import tagSelectCascader from '@components/tag-select-cascader'
export default {
  name: 'ExaminationManage',
  components: { ListTableActionDialog },
  // 第一步，定义表单类型，字段选择
  data () {
    return {
      // 表单配置数据
      config: {
        selectAll: false,
        // 列表模式
        mode: 'table',
        name: 'ExaminationManage',
        // 列表配置
        list: List
      },
      formSchema: {
        tags: {
          type: 'Array',
          value: [],
          defaultValue: [],
          width: '320',
          placeholder: '选择标签（多选）',
          ui: {
            widget: tagSelectCascader, // 组件名
            widgetConfig: {
              tip: false
            } // 组件配置
          }
        },
        name: {
          type: 'string',
          value: '',
          defaultValue: '',
          label: '',
          width: '240',
          placeholder: '输入名称',
          ui: {
            widget: 'MkInput', // 组件名
            widgetConfig: {} // 组件配置
          }
        }
      },
      // 表单数据
      data: [],
      // 查询参数
      params: {
        name: '',
        page: 1,
        pageSize: 10,
        tags: []
      },
      total: 1,
      // 是否打开删除/编辑失败（关联学习任务）弹窗
      isOpenDelete: false,
      // 弹窗 内容
      dialogContent: {
        titie: '',
        text: ''
      }

    }
  },
  // created () {
  //   this.paperListPost()
  // },
  activated () {
    this.paperListPost()
  },
  methods: {
    // 事件
    // ajax 请求
    // 数据处理方法 or 其他方法
    // 新建考试
    handleOnOpenClick () {
      this.$router.push({
        path: '/business-school/examination-manage/create-edit-examination'
      })
    },
    // 搜索
    handleOnSearchClick (params) {
      let tags = this.util.levelTagsToTags(params.tags)
      this.handleSearchReset({ ...params, tags: tags })
    },
    // 重置
    handleOnResetClick (params) {
      this.handleSearchReset(params)
    },
    // 搜索或重置时 参数处理以及接口调用
    handleSearchReset (params) {
      this.params = {
        ...params,
        page: 1,
        pageSize: 10
      }
      this.paperListPost()
    },
    // 翻页
    handleOnCurrentChange (value) {
      this.params.page = value
      this.paperListPost()
    },
    // 获取数据
    async paperListPost () {
      let { success, msg, data: { data, count } } = await MBASVCAPIS.PaperApi.paperListPost(this.params)
      if (success) {
        data.forEach((item) => {
          item.createrPerson = item.creator
        })
        this.total = count
        this.data = data
      }
    },
    // 删除数据事件
    handleOnDeleteChange (val) {
      let params = {
        _id: val._id
      }
      this.paperDeleteDelete(params)
    },
    // 删除接口
    async paperDeleteDelete (params) {
      let res = await MBASVCAPIS.PaperApi.paperDeleteDelete(params)
      if (res.success) {
        if (res.code === 20002001) {
          this.dialogContent = {
            title: '删除失败',
            text: '该考试已关联学习任务，不能被删除，请先从任务中移除。'
          }
          // 已关联任务 不可删除
          this.isOpenDelete = true
        } else {
          // 删除成功
          this.$message.success('删除成功')
          this.paperListPost()
        }
      } else {
      }
    },
    // 关闭 删除时已关联学习任务，不能被删除的提示弹窗弹窗
    handleOnDeleteEnterClick () {
      this.isOpenDelete = false
    },
    // 编辑 考试列表跳转
    handleEditExamination (val) {
      let params = {
        _id: val._id
      }
      this.paperCheckPaperOperationStatusGet(params)
    },
    // 编辑前校验是否 已关联任务
    async paperCheckPaperOperationStatusGet (params) {
      let res = await MBASVCAPIS.PaperApi.paperCheckPaperOperationStatusGet(params)
      if (res.success) {
        if (res.code === 20002001) {
          this.dialogContent = {
            title: '编辑失败',
            text: '该考试已关联学习任务，不能被编辑，请先从任务中移除。'
          }
          // 已关联任务 不可编辑
          this.isOpenDelete = true
        } else {
          // 可编辑 进行跳转
          let query = { _id: params._id }
          this.$router.push({
            path: '/business-school/examination-manage/create-edit-examination',
            query: query
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.examination-manage {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
  overflow: hidden;

  .examination-manage-table-wrapper {
    height: 0;
    flex: 1;
  }
}
</style>
